/* istanbul ignore file */
import Axios from 'axios';
import Auth from './auth';
import { getCorrelationId } from '../utils/telemetryUtils';
import { DOCUMENT_STATUSES, SUPPRESS_ANALYTICS_EVENT } from '../constants';

const correlationId = getCorrelationId();

function sendRequest(
  url,
  method,
  data = null,
  sendBearerToken = true,
  contentType = '',
  accept = 'application/json',
  cacheControl = 'no-cache',
  suppressAnalyticsEvent = false,
) {
  const headers = {
    'Content-Type': contentType,
    Accept: accept,
    'cache-control': cacheControl,
    'x-correlation-id': correlationId,
    ...(suppressAnalyticsEvent && { [SUPPRESS_ANALYTICS_EVENT]: true }),
  };

  if (sendBearerToken && Auth.isLoggedIn()) {
    headers.Authorization = `Bearer ${Auth.getToken()}`;
  }
  const requestOptions = {
    url,
    method,
    headers,
    data,
  };
  return Axios.request(requestOptions);
}

function get(
  url,
  sendBearerToken = true,
  contentType = 'application/json',
  accept = 'application/json',
  cacheControl = 'no-cache',
) {
  return this.sendRequest(url, 'GET', null, sendBearerToken, contentType, accept, cacheControl);
}

function post(
  url,
  data = null,
  sendBearerToken = true,
  contentType = 'application/json',
  accept = 'application/json',
  cacheControl = 'no-cache',
  suppressAnalyticsEvent = false,
) {
  return this.sendRequest(
    url,
    'POST',
    data,
    sendBearerToken,
    contentType,
    accept,
    cacheControl,
    suppressAnalyticsEvent,
  );
}

function patch(
  url,
  data = null,
  sendBearerToken = true,
  contentType = 'application/json',
  accept = 'application/json',
  cacheControl = 'no-cache',
) {
  return this.sendRequest(url, 'PATCH', data, sendBearerToken, contentType, accept, cacheControl);
}

function upload(
  url,
  file,
  suppressAnalyticsEvent = false,
  sendBearerToken = true,
  contentType = 'multipart/form-data',
  accept = 'application/json',
  cacheControl = 'no-cache',
) {
  const formData = new FormData();
  formData.append('file', file, file.Name);
  formData.append('documentStatus', DOCUMENT_STATUSES.Uploaded);
  return this.post(
    url,
    formData,
    sendBearerToken,
    contentType,
    accept,
    cacheControl,
    suppressAnalyticsEvent,
  );
}

function deleteRequest(url) {
  return this.sendRequest(url, 'DELETE');
}

export default {
  sendRequest,
  get,
  post,
  patch,
  upload,
  deleteRequest,
};
